import React, { useEffect, useMemo, useState } from "react";
import { BiHide, BiShowAlt } from "react-icons/bi";
import { BsCheckCircleFill } from "react-icons/bs";
import { MdCancel } from "react-icons/md";
import MirageLoader from "../ui/pageLoader/MirageLoader";

const RegisterForm = (props) => {
  const {
    registerError,
    registerForm,
    userRegistration,
    registerInput,
    errorsData,
    checkPhone,
    checkEmail,
    checkUsername,
    registerVisible,
    setRegisterVisible,
    confirmregisterVisible,
    setConfirmRegisterVisible,
    handlePasswordValidate,
    isButtonClicked,
  } = props;

  const [enableButton, setEnableButton] = useState(false);

  const emailRegex = useMemo(() => /^[^\s@]+@[^\s@]+\.[^\s@]+$/, []);
  
  useEffect(() => {
    const filterMap = Object.entries(userRegistration).every(
      ([key, value]) => value !== null && value !== "",
    );
    if (
      filterMap &&
      userRegistration.password &&
      userRegistration.password !== "" &&
      userRegistration.password2 &&
      userRegistration.password2 !== "" &&
      userRegistration.mobile.length === 10 &&
      emailRegex.test(userRegistration.email) &&
      errorsData.password.length === 0 &&
      errorsData.password2.length === 0
    ) {
      setEnableButton(true);
    } else {
      setEnableButton(false);
    }
  }, [userRegistration, checkUsername, errorsData, emailRegex]);

  return (
    <form onSubmit={registerForm} action="">
      <div className="flex flex-wrap justify-start gap-4 md:flex-nowrap md:gap-8">
        <div className="w-full md:w-[322px]">
          <div className="h-[125px]">
            <label
              className="pb-[10px] font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E]"
              htmlFor="first_name"
            >
              First Name*
            </label>
            <input
              className="mb-[5px] mt-[12px] w-full rounded-[8px] border border-[#B6B6B6] bg-[#F7F7F7] px-[16px] py-[12px] font-open text-[16px] font-[400] leading-[24px] text-[#636363] outline-0"
              type="text"
              name="first_name"
              autoComplete="off"
              value={userRegistration.first_name}
              onChange={registerInput}
              placeholder="Enter Here"
            />
            {errorsData.first_name && (
              <span className="error">{errorsData.first_name}</span>
            )}
          </div>
        </div>
        <div className="w-full md:w-[322px]">
          <div className="h-[125px]">
            <label
              className="pb-[10px] font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E]"
              htmlFor="last_name"
            >
              Last Name*
            </label>
            <input
              className="mb-[5px] mt-[12px] w-full rounded-[8px] border border-[#B6B6B6] bg-[#F7F7F7] px-[16px] py-[12px] font-open text-[16px] font-[400] leading-[24px] text-[#636363] outline-0"
              type="text"
              name="last_name"
              autoComplete="off"
              value={userRegistration.last_name}
              onChange={registerInput}
              placeholder="Enter Here"
            />
            {errorsData.last_name && (
              <span className="error">{errorsData.last_name}</span>
            )}
          </div>
        </div>
      </div>

      <div className="flex flex-wrap justify-start gap-4 md:flex-nowrap md:gap-8">
        <div className="w-full md:w-[322px]">
          <div className="mt-[10px] h-[125px]">
            <label
              className="pb-[10px] font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E]"
              htmlFor="email"
            >
              Email Address*
            </label>
            <input
              className="mb-[5px] mt-[12px] w-full rounded-[8px] border border-[#B6B6B6] bg-[#F7F7F7] px-[16px] py-[12px] font-open text-[16px] font-[400] leading-[24px] text-[#636363] outline-0"
              type="email"
              name="email"
              autoComplete="off"
              value={userRegistration.email}
              onChange={registerInput}
              placeholder="Enter Here"
              onBlur={() => {
                checkEmail("api/check-email");
              }}
            />
            {emailRegex.test(userRegistration.email) ? (
              checkUsername?.email === true &&
              checkUsername?.email !== "empty" ? (
                <MdCancel
                  className="relative float-right mr-[15px] mt-[-38px] cursor-pointer"
                  color="red"
                />
              ) : (
                <BsCheckCircleFill
                  className="relative float-right mr-[15px] mt-[-38px] cursor-pointer"
                  color="green"
                />
              )
            ) : null}

            {emailRegex.test(userRegistration.email) &&
              checkUsername?.email &&
              checkUsername?.email !== "empty" && (
                <span className="error">
                  {checkUsername?.email ? "Email already exits" : ""}
                </span>
              )}
          </div>
        </div>
        <div className="w-full md:w-[322px]">
          <div className="mt-[10px] h-[125px]">
            <label
              className="pb-[10px] font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E]"
              htmlFor="mobile"
            >
              Mobile Number*
            </label>
            <div className="register-number">
              <div className="w-[20%]">
                <img src="images/Country-numbr.png" alt="" />
              </div>
              <input
                className="w-[80%] bg-[#F7F7F7] font-open text-[16px] font-[400] leading-[24px] text-[#636363] outline-0"
                type="number"
                name="mobile"
                autoComplete="off"
                value={userRegistration.mobile}
                maxLength={10}
                placeholder="Enter Here"
                onChange={(e) => {
                  const onlyDigits = e.target.value.replace(/[^0-9]/g, "");
                  registerInput({
                    target: {
                      name: e.target.name,
                      value: onlyDigits.slice(0, 10),
                    },
                  });
                }}
                onBlur={() => {
                  checkPhone("api/check-phone");
                }}
              />
            </div>
            {userRegistration.mobile.length === 10 ? (
              checkUsername?.phone === true &&
              checkUsername?.phone !== "empty" ? (
                <MdCancel
                  className="relative float-right mr-[15px] mt-[-38px] cursor-pointer"
                  color="red"
                />
              ) : (
                <BsCheckCircleFill
                  className="relative float-right mr-[15px] mt-[-38px] cursor-pointer"
                  color="green"
                />
              )
            ) : null}
            {userRegistration.mobile.length === 10 &&
              checkUsername?.phone &&
              checkUsername?.phone !== "empty" && (
                <span className="error">
                  {checkUsername?.phone ? "Mobile number already exits" : ""}
                </span>
              )}
          </div>
        </div>
      </div>

      <div className="flex flex-wrap justify-start gap-4 md:flex-nowrap md:gap-8">
        <div className="w-full md:w-[322px]">
          <div className="mt-[10px] h-[125px]">
            <div className="password-hover">
              <label
                className="mb-[5px] font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E]"
                htmlFor="password"
              >
                Create New Password
              </label>
              <div className="password-aline">
                <div className="hover-imgs">
                  <img src="images/info-img.png" alt="" />
                </div>
                <div className="password-hover-show">
                  <img src="images/hovers-img.png" alt="" />
                </div>
              </div>
            </div>

            <input
              className="mb-[5px] mt-[12px] w-full rounded-[8px] border border-[#B6B6B6] bg-[#F7F7F7] px-[16px] py-[12px] font-open text-[16px] font-[400] leading-[24px] text-[#636363] outline-0"
              type={registerVisible ? "text" : "password"}
              name="password"
              autoComplete="off"
              value={userRegistration.password}
              onChange={(e) => {
                registerInput(e);
                handlePasswordValidate(e);
              }}
              placeholder="Enter Here"
            />

            <button
              className="registr-visib-icns"
              type="button"
              onClick={() => setRegisterVisible(!registerVisible)}
            >
              {registerVisible ? <BiShowAlt /> : <BiHide />}
            </button>
            <div className="error-btn">
              {errorsData.password.length === 1 ? (
                <span className="error">{errorsData.password}</span>
              ) : (
                <ul>
                  {errorsData.password.map((error, index) => {
                    return (
                      <li key={index}>
                        <span className="error">{error}</span>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </div>
        </div>

        <div className="w-full md:w-[322px]">
          <div className="mt-[10px] h-[125px]">
            <label
              className="pb-[10px] font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E]"
              htmlFor="password2"
            >
              Confirm Password*
            </label>
            <input
              className="mb-[5px] mt-[12px] w-full rounded-[8px] border border-[#B6B6B6] bg-[#F7F7F7] px-[16px] py-[12px] font-open text-[16px] font-[400] leading-[24px] text-[#636363] outline-0"
              type={confirmregisterVisible ? "text" : "password"}
              name="password2"
              autoComplete="off"
              value={userRegistration.password2}
              onChange={(e) => {
                registerInput(e);
                handlePasswordValidate(e);
              }}
              // onBlur={handlePasswordValidate}
              placeholder="Enter Here"
            />
            <button
              className="registr-visib-icns"
              type="button"
              onClick={() => setConfirmRegisterVisible(!confirmregisterVisible)}
            >
              {confirmregisterVisible ? <BiShowAlt /> : <BiHide />}
            </button>
            {errorsData.password2 && (
              <span className="error">{errorsData.password2}</span>
            )}
          </div>
        </div>
      </div>
      <div>
        {registerError && <p>{registerError}</p>}
        <div className="mt-[40px] w-full md:w-[322px]">
          <button
            disabled={!enableButton || isButtonClicked}
            className={`${
              !enableButton || isButtonClicked
                ? "opacity-[70%]"
                : "cursor-pointer hover:bg-[#A94829]"
            } mt-[40px] w-full rounded-[6px] bg-[#F2673A] px-[24px] py-[10px] font-open text-[16px] font-[600] tracking-[0.003px] text-[#ffffff] md:px-[32px] md:py-[13px]`}
            type="submit"
          >
            {isButtonClicked ? <MirageLoader /> : "Register"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default RegisterForm;